import React, { useState, useEffect } from "react";
import {AccessKey, SecretAccessKey} from "./awsKeys"

const AWS = require("aws-sdk");

AWS.config.update({
  accessKeyId: AccessKey,
  secretAccessKey: SecretAccessKey,
  region: 'ap-southeast-1'
});

const dynamodocclient = new AWS.DynamoDB.DocumentClient();
var s3 = new AWS.S3();

const Table = ({theadData, tbodyData}) => {
    return (
        <table>
            <thead>
                <tr>
                    {theadData.map((heading, index)=> {
                        if (heading !== 'dummy') {
                            return <th key={index}>{heading}</th>
                        }
                        return null;
                    })}
                </tr>
            </thead>
            <tbody>
                {tbodyData.map((row, index) => {
                    return <tr key={index}>
                        {theadData.map((key, index) => {
                            if (key !== 'dummy') {
                                return <td key={index}>{row[key]}</td>
                            }
                            return null;
                        })}
                    </tr>;
                })}
            </tbody>
        </table>
    );
}

const Logs = () => {
    const [logs, setLogs] = useState([{'loading...':'please be patient'}]);
    const [users, setUsers] = useState([{'loading...':'please be patient'}]);

    useEffect(() => {
      const intervalId = setInterval(() => {
        dynamodocclient.query({TableName: "aisglogs",  IndexName: "dummy-index", KeyConditionExpression: "dummy = :a", ExpressionAttributeValues: {':a': "help"}, Limit: '15', ScanIndexForward: false}, function (err, data) {
            if (err) {
              console.error("Error", err);
            } else {
              console.log("Success");
              setLogs(data.Items);
            }
        });
        dynamodocclient.query({TableName: "aisgusers", IndexName: "dummy-index", KeyConditionExpression: "dummy = :a", ExpressionAttributeValues: {':a': "help"}, Limit: '15', ScanIndexForward: false}, function (err, data) {
            if (err) {
                console.error("Error", err);
            } else {
                console.log("Success");
                setUsers(data.Items);
            }
        });
      }, 1000);
      return () => clearInterval(intervalId);
    }, []);

    var proc_url = "https://aisgpics.s3.ap-southeast-1.amazonaws.com/txb_230217_114515.jpg?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLXNvdXRoZWFzdC0xIkgwRgIhAP1oP7FgWADT51defuG%2Fw6BqL4STNUBUUCrPEfJXUqagAiEA8dSXj70%2Fz69loEQAitTLoaT%2Fa%2Bjx0A1gPsKSk6aFGswqhQMIVRAAGgwzNTQxNDU2MjY4NjAiDGjL%2BK7SaHUJZ8RcjiriApwM6CT6KYGtAr6a2yciciiQmT5UMUAxE7wHYarVLWwHrUWe3vxoqs%2Bb1VA5FVL5njY1xTQ0J1AsPTbIxJ86jJV1ClfDZEZ4gtwinMNT%2FJHtAazskWH%2F%2FXUKIMu%2BCqsgFVEpL0dtfFaOZJuERs50T%2FT2JYBjQ9rgm6%2FbAtGTUrWdB%2FJeksOgevI3dHB9sg38VWzrFuemO1Ju9fXN3z%2BLSIiHddq%2FU1kj0YddIgqbuv3PcY8zpOn9GEZXIv1qj0lJ0WrwIvfjkHDcomNqBun%2BpPjjO%2Fb1qcLzTMag%2Bp5flhT3SQCxm2Y3aV3PkrvbWV%2B9XlQVrluaGtITHQRa6znw9gn5DtYRTV9D38aOPYlV6S2UrVUv1gIo2he0UJkOhsMyDCOUw4%2BSRryfRFplROBxGOP%2F%2Bvoxz6a8ugQTFgzk3iD8zGWXmGwBJPwQIBGgNwQD0Cqd5p2OhR9ncLt4emMw2igTfTCR47ufBjqyAu6X2MxnGPZruphGT05Bh24MI2b4%2BIOBeYzugP5ADQdlCXtykcZf%2FHqz%2BQURbl2DptJtyLuJ3afH%2B80tGbHh3MYweo2T6P7N0ZIG1mHzMLMFCe7Y%2By5CrEJ3U%2Bnf5JA0KcDzUqcPTgTen1vTwe2g3O9kNx%2Fk684E%2BbFGDS551jI%2BPzBG6jqTLMLwl6p%2FE%2BWl%2F%2FUIDLEvyjD%2BvJ89zbF9cjekV5nJGzsqfgrHCgWDFTdvM03OKZjUjBFY0%2Fq91d3WWpwHkrLqCvBTJgumKs6Cl2M0Xhfxf5BD%2FVI79hjyKkYo7WD9iXnxrP1aIAuQQgyIwC9mrZSDrrHLPtJOs2f8A7NMY2eNkmxKZLLt46P1ilrbcUg9%2Fzd2Tu1EMdXDqITGo6DiCmfyNQniHzzFsgYa8gq7mA%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230217T035113Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Credential=ASIAVE5FZNLWP6EDK3FO%2F20230217%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=3587ce5ba7fb2865f708f00b3437f4c318b5a8693a31df867fea3e174ff5748c";
    var raw_url = "https://aisgpics.s3.ap-southeast-1.amazonaws.com/txb_230217_114513.jpg?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLXNvdXRoZWFzdC0xIkgwRgIhAP1oP7FgWADT51defuG%2Fw6BqL4STNUBUUCrPEfJXUqagAiEA8dSXj70%2Fz69loEQAitTLoaT%2Fa%2Bjx0A1gPsKSk6aFGswqhQMIVRAAGgwzNTQxNDU2MjY4NjAiDGjL%2BK7SaHUJZ8RcjiriApwM6CT6KYGtAr6a2yciciiQmT5UMUAxE7wHYarVLWwHrUWe3vxoqs%2Bb1VA5FVL5njY1xTQ0J1AsPTbIxJ86jJV1ClfDZEZ4gtwinMNT%2FJHtAazskWH%2F%2FXUKIMu%2BCqsgFVEpL0dtfFaOZJuERs50T%2FT2JYBjQ9rgm6%2FbAtGTUrWdB%2FJeksOgevI3dHB9sg38VWzrFuemO1Ju9fXN3z%2BLSIiHddq%2FU1kj0YddIgqbuv3PcY8zpOn9GEZXIv1qj0lJ0WrwIvfjkHDcomNqBun%2BpPjjO%2Fb1qcLzTMag%2Bp5flhT3SQCxm2Y3aV3PkrvbWV%2B9XlQVrluaGtITHQRa6znw9gn5DtYRTV9D38aOPYlV6S2UrVUv1gIo2he0UJkOhsMyDCOUw4%2BSRryfRFplROBxGOP%2F%2Bvoxz6a8ugQTFgzk3iD8zGWXmGwBJPwQIBGgNwQD0Cqd5p2OhR9ncLt4emMw2igTfTCR47ufBjqyAu6X2MxnGPZruphGT05Bh24MI2b4%2BIOBeYzugP5ADQdlCXtykcZf%2FHqz%2BQURbl2DptJtyLuJ3afH%2B80tGbHh3MYweo2T6P7N0ZIG1mHzMLMFCe7Y%2By5CrEJ3U%2Bnf5JA0KcDzUqcPTgTen1vTwe2g3O9kNx%2Fk684E%2BbFGDS551jI%2BPzBG6jqTLMLwl6p%2FE%2BWl%2F%2FUIDLEvyjD%2BvJ89zbF9cjekV5nJGzsqfgrHCgWDFTdvM03OKZjUjBFY0%2Fq91d3WWpwHkrLqCvBTJgumKs6Cl2M0Xhfxf5BD%2FVI79hjyKkYo7WD9iXnxrP1aIAuQQgyIwC9mrZSDrrHLPtJOs2f8A7NMY2eNkmxKZLLt46P1ilrbcUg9%2Fzd2Tu1EMdXDqITGo6DiCmfyNQniHzzFsgYa8gq7mA%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230217T035029Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Credential=ASIAVE5FZNLWP6EDK3FO%2F20230217%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=267334d6ef96097feffdca8a821ac1cc1982b462091f37f09025f9182de29e35";
    
    return (
      <div className="Logs">
        <div className="container-fluid col text-center">
            <div className="row mx-auto mb-5">
                <img className="w-50" src={proc_url} alt="processed footage"/>
                <img className="w-50" src={raw_url} alt="processed footage"/>
            </div>
            <h2>User Information Derived from Logs (last 15 items)</h2>
            <div className="row text-start my-5">
                <Table theadData={Object.keys(users[0])} tbodyData={users}/>
            </div>
            <h2>Logs from PeekingDuck (last 15 items)</h2>
            <div className="row text-start my-5">
                <Table theadData={Object.keys(logs[0])} tbodyData={logs}/>
            </div>
        </div>
      </div>
    );
}

export default Logs;
